export function estimateEmi(amount, tenureMonths, interestMode, annualRate) {
  const principal = Number(amount) || 0;
  const n = Number(tenureMonths) || 0;
  if (principal <= 0 || n <= 0) return 0;
  const yearly = Number(annualRate) || 0;
  const mode = interestMode || "interest_free";
  if (mode === "interest_free" || yearly <= 0) {
    return Math.round((principal / n) * 100) / 100;
  }
  if (mode === "flat") {
    const interest = principal * (yearly / 100) * (n / 12);
    return Math.round(((principal + interest) / n) * 100) / 100;
  }
  const r = yearly / 100 / 12;
  const emi = (principal * r * (1 + r) ** n) / ((1 + r) ** n - 1);
  return Math.round(emi * 100) / 100;
}

export function firstDeductionMonthLabel(delayMonths) {
  const delay = Math.max(0, Number(delayMonths) || 0);
  const d = new Date();
  d.setDate(1);
  d.setMonth(d.getMonth() + delay);
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}`;
}
